import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Head } from "../Head";
type Breadcrumb = {
  label: string;
  path?: string;
};

type PageLayoutProps = {
  breadcrumbs: Breadcrumb[];
  children: ReactNode;
  searchComponent?: ReactNode;
  addAction?: ReactNode;
  selectComponent?: ReactNode;
};

export const PageLayout = ({
  breadcrumbs,
  children,
  searchComponent,
  addAction,
  selectComponent,
}: PageLayoutProps) => {
  const navigate = useNavigate();

  return (
    <>
    <Head title={breadcrumbs[0].label}/>
    <div className="py-4">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center gap-2 text-sm">
            {breadcrumbs.map((crumb, i) => (
              <div key={i} className="flex items-center gap-2">
                {crumb.path ? (
                  <button
                    onClick={() => navigate(crumb.path)}
                    className="px-2 py-1 rounded-md transition font-medium 
                               text-white bg-black 
                               hover:bg-red-600 hover:text-white
                               data-[active=true]:bg-red-600"
                    data-active={!crumb.path} 
                  >
                    {crumb.label}
                  </button>
                ) : (
                  <span className="px-2 py-1 rounded-md bg-red-600 text-white font-semibold">
                    {crumb.label}
                  </span>
                )}
                {i < breadcrumbs.length - 1 && <span>/</span>}
              </div>
            ))}
          </div>

          <div className="flex items-center gap-1 px-1">
            {searchComponent}
            {selectComponent}
            {addAction}
          </div>
        </div>
        <div>{children}</div>
      </div>
    </div>
    </>
  );
};
